/* MIRALIVIA — global behaviour */

/* Un solo envoltorio para todo el archivo: asi los ayudantes de seleccion
   viven en un unico sitio y ningun modulo de abajo necesita redeclararlos.
   Antes cada bloque era una IIFE hermana y solo la primera los tenia, asi
   que escribir $() en cualquier otra lanzaba un ReferenceError que, al no
   capturarse, abortaba todo lo que venia despues. */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* Cada modulo se monta aislado. Si uno falla al arrancar se registra en
     consola y los demas siguen adelante, en vez de llevarse por delante el
     resto del archivo. No cubre lo que ocurra mas tarde dentro de un
     listener: eso salta cuando el try ya ha terminado. */
  function mod(name, fn) {
    try {
      fn();
    } catch (e) {
      console.error('[ML] fallo al montar el modulo "' + name + '"', e);
    }
  }
  mod('global', function () {
    'use strict';

    /* ---------------- Overlay + body lock ---------------- */
    const overlay = $('[data-overlay]');
    let openPanels = 0;

    function lock() {
      openPanels++;
      document.body.classList.add('no-scroll');
      if (overlay) overlay.classList.add('is-open');
    }
    function unlock(force) {
      openPanels = force ? 0 : Math.max(0, openPanels - 1);
      if (openPanels === 0) {
        document.body.classList.remove('no-scroll');
        if (overlay) overlay.classList.remove('is-open');
      }
    }

    function closeAll() {
      $$('[data-panel].is-open').forEach((p) => p.classList.remove('is-open'));
      $$('[aria-expanded="true"][data-panel-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      unlock(true);
    }
    window.MLcloseAll = closeAll;
    /* El panel de filtros de coleccion reutiliza este mismo bloqueo y velo,
       en vez de montar otro sistema en paralelo. */
    window.MLlock = lock;
    window.MLunlock = unlock;

    function openPanel(id) {
      const panel = document.getElementById(id);
      if (!panel) return;
      panel.classList.add('is-open');
      lock();
      const focusable = panel.querySelector('[data-autofocus]') || panel.querySelector('button, a, input');
      if (focusable) setTimeout(() => focusable.focus(), 260);
    }
    window.MLopenPanel = openPanel;

    function closePanel(panel) {
      if (!panel) return;
      panel.classList.remove('is-open');
      unlock();
    }

    document.addEventListener('click', function (e) {
      const toggle = e.target.closest('[data-panel-toggle]');
      if (toggle) {
        e.preventDefault();
        const id = toggle.getAttribute('data-panel-toggle');
        const panel = document.getElementById(id);
        if (!panel) return;
        if (panel.classList.contains('is-open')) {
          closePanel(panel);
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          openPanel(id);
          toggle.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      if (e.target.closest('[data-panel-close]') || e.target.closest('[data-overlay]')) {
        closeAll();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      /* Si hay una capa abierta por encima, Escape es suya. Sin esto, cerrar
         el selector de tallas dentro de las recomendaciones del carrito se
         llevaba tambien el cajon entero. */
      if (document.querySelector('[data-quick-add].is-open, .rev-lb.is-open, .lightbox.is-open')) return;
      closeAll();
    });

    /* ---------------- Sticky header shadow ----------------
       El nodo se relee en cada scroll a proposito: cada cambio del carrito
       re-renderiza la cabecera, y la referencia guardada al cargar quedaba
       apuntando a un nodo ya desprendido del documento. */
    const onScroll = function () {
      const h = $('[data-header]');
      if (h) h.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    /* ---------------- Announcement rotation ---------------- */
    $$('[data-announcement]').forEach(function (bar) {
      const slides = $$('.announcement__slide', bar);
      if (slides.length < 2) return;
      let i = 0;
      const speed = parseInt(bar.dataset.speed || '5', 10) * 1000;
      const go = (n) => {
        slides[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
      };
      setInterval(() => go(i + 1), speed);
    });

    /* ---------------- Predictive search ----------------
       Delegado en document y no enganchado al input: la cabecera se
       re-renderiza con cada cambio del carrito, asi que el listener directo
       moria con el campo y el buscador quedaba inerte el resto de la sesion.

       La ruta sale de Shopify.routes cuando esta disponible, para que una
       tienda con prefijo de idioma no consulte el locale equivocado. */
    let searchTimer, searchAbort;
    document.addEventListener('input', function (e) {
      const input = e.target.closest('[data-search-input]');
      if (!input) return;
      const results = $('[data-search-results]');
      if (!results) return;
      clearTimeout(searchTimer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      /* La busqueda predictiva de Shopify exige la palabra COMPLETA: "avel" no
         encontraba "Avélia" y solo aparecia al teclear el nombre entero, que es
         justo lo contrario de para lo que sirve un desplegable de sugerencias.
         El asterisco la convierte en busqueda por prefijo.

         Comprobado contra la tienda: q=avel no devuelve nada, q=avel* devuelve
         el vestido. Es el mismo truco que ya se aplicaba al pulsar Enter, que
         por eso si lo encontraba; aqui faltaba.

         Se añade solo a la ultima palabra -que es la que se esta escribiendo- y
         nunca si ya la lleva. */
      const qStar = q.slice(-1) === '*' ? q : q + '*';
      searchTimer = setTimeout(function () {
        if (searchAbort) searchAbort.abort();
        searchAbort = new AbortController();
        const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.predictive_search_url) || '/search/suggest';
        fetch(
          base + '?q=' + encodeURIComponent(qStar) +
          '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search',
          { signal: searchAbort.signal }
        )
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(() => {});
      }, 220);
    });

    /* ---------------- Reveal on scroll ---------------- */
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
          });
        },
        { rootMargin: '0px 0px -8% 0px' }
      );
      $$('.reveal').forEach((el) => io.observe(el));
    } else {
      $$('.reveal').forEach((el) => el.classList.add('is-in'));
    }

    /* ---------------- Accordion: one open at a time (optional) ---------------- */
    function initAccordions(scope) {
      $$('[data-accordion-exclusive]', scope || document).forEach(function (wrap) {
        if (wrap.dataset.accReady) return;
        wrap.dataset.accReady = '1';
        $$('details', wrap).forEach(function (d) {
          d.addEventListener('toggle', function () {
            if (!d.open) return;
            $$('details', wrap).forEach((o) => {
              if (o === d || !o.open) return;
              /* Los que se cierran solos al abrir otro tambien se animan. Con
                 `o.open = false` a secas desaparecian de golpe mientras el
                 recien abierto se desplegaba con calma, y el salto se notaba
                 mas que si no hubiera animacion en ninguno. */
              if (o.hasAttribute('data-smooth') && window.MLsmoothClose) window.MLsmoothClose(o);
              else o.open = false;
            });
          });
        });
      });
    }
    initAccordions();
    /* Secciones anadidas desde el Personalizador tambien necesitan engancharse. */
    document.addEventListener('shopify:section:load', function (e) { initAccordions(e.target); });

    /* ---------------- Quantity steppers ---------------- */
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      const wrap = btn.closest('[data-qty]');
      const input = $('input', wrap);
      const step = parseInt(btn.dataset.qtyChange, 10);
      const min = parseInt(input.min || '1', 10);
      let val = parseInt(input.value || '1', 10) + step;
      if (val < min) val = min;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- Footer accordions ----------
     The `open` attribute is always present in the HTML so desktop shows the
     menus even if JS fails. On mobile we collapse them here. CSS alone can no
     longer reveal <details> content, because Chrome renders it through the
     ::details-content pseudo-element with content-visibility. */
  mod('footer-accordions', function () {
    var mq = window.matchMedia('(max-width: 749px)');
    function sync() {
      document.querySelectorAll('[data-footer-acc]').forEach(function (d) {
        d.open = mq.matches ? d.hasAttribute('data-open-mobile') : true;
      });
    }
    sync();
    if (mq.addEventListener) { mq.addEventListener('change', sync); } else { mq.addListener(sync); }
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('shopify:block:select', sync);
  });

  /* ---------- Busqueda: coincidencia por prefijo ----------
     La busqueda de Shopify exige la palabra completa, asi que "Céles" no
     encuentra nada. El asterisco final convierte la ultima palabra en prefijo.

     La predictiva tiene exactamente la misma limitacion -aqui se dio por hecho
     que no, y era falso: q=avel no devuelve nada contra esta tienda-, asi que
     alli se añade el mismo asterisco. Las dos coinciden ahora en lo que
     encuentran, que es lo que se espera al pulsar Enter sobre lo que ya se
     estaba viendo. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/search"]');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var value = input.value.trim();
    if (value && value.slice(-1) !== '*') input.value = value + '*';
  });

  /* ---------- Grid quick add ----------
     Adds straight to the cart from a product grid. One variant adds immediately;
     several options open a compact picker on the card so the shopper can choose
     size AND colour without opening the product page. */
  mod('quick-add', function () {
    function variants(wrap) {
      const tag = wrap.querySelector('[data-quick-variants]');
      if (!tag) return [];
      try { return JSON.parse(tag.textContent); } catch (e) { return []; }
    }

    function selection(wrap) {
      return Array.from(wrap.querySelectorAll('[data-quick-row]')).map(function (row) {
        const active = row.querySelector('.is-active');
        return active ? active.dataset.quickValue : null;
      });
    }

    function match(wrap) {
      const chosen = selection(wrap);
      return variants(wrap).find(function (v) {
        return chosen.every(function (val, i) { return val === null || v.o[i] === val; });
      });
    }

    /* Grey out combinations that don't exist, the way the product page does. */
    function syncAvailability(wrap) {
      const list = variants(wrap);
      const chosen = selection(wrap);
      wrap.querySelectorAll('[data-quick-row]').forEach(function (row, idx) {
        row.querySelectorAll('[data-quick-value]').forEach(function (btn) {
          const test = chosen.slice();
          test[idx] = btn.dataset.quickValue;
          const ok = list.some(function (v) {
            return v.a && test.every(function (val, i) { return val === null || v.o[i] === val; });
          });
          btn.classList.toggle('is-unavailable', !ok);
        });
      });

      const confirm = wrap.querySelector('[data-quick-confirm]');
      if (confirm) {
        const v = match(wrap);
        confirm.disabled = !v || !v.a;
      }
    }

    function add(wrap, variantId) {
      if (!window.MLaddVariant) return;
      const btn = wrap.querySelector('[data-quick-open], [data-quick-single]');
      const confirm = wrap.querySelector('[data-quick-confirm]');
      const target = confirm || btn;
      if (!target) return;
      /* innerHTML y no textContent: el boton de la tarjeta lleva dentro el
         icono de bolsa y el span del texto, y restaurar con textContent los
         destruia. En movil el CSS oculta ese span, asi que al perderlo el
         literal se salia del boton redondo. */
      const original = target.innerHTML;
      target.disabled = true;
      if (confirm) confirm.textContent = '…';

      window.MLaddVariant(variantId, 1)
        .then(function () {
          if (btn) btn.classList.add('is-done');
          closeAll();
          if (window.MLopenPanel) window.MLopenPanel('cart-drawer');
          setTimeout(function () {
            if (btn) btn.classList.remove('is-done');
            target.innerHTML = original;
            target.disabled = false;
          }, 1500);
        })
        .catch(function () {
          target.innerHTML = original;
          target.disabled = false;
        });
    }

    function closeAll() {
      document.querySelectorAll('[data-quick-add].is-open').forEach(function (w) {
        w.classList.remove('is-open');
        const panel = w.querySelector('[data-quick-panel]');
        const opener = w.querySelector('[data-quick-open]');
        if (panel) {
          /* Se quita la clase que lo tiene a la vista y el `hidden` se retrasa
             hasta que la transicion acaba: ponerlo ya lo haria desaparecer de
             golpe -display:none no se anima- y no habria cierre que ver.
             Al volver se comprueba que siga cerrado, por si se reabrio entre
             medias. */
          panel.classList.remove('is-shown');
          setTimeout(function () {
            if (!w.classList.contains('is-open')) panel.hidden = true;
          }, 220);
        }
        if (opener) opener.setAttribute('aria-expanded', 'false');
        const card = w.closest('.card');
        if (card) card.classList.remove('is-quick-open');
      });
    }

    document.addEventListener('click', function (e) {
      /* El velo de la hoja es un ::before de [data-quick-add], asi que tocarlo
         llega aqui con ese mismo elemento como target, nunca con un hijo. Sirve
         para distinguirlo de un toque en el boton o dentro del panel. */
      const veil = e.target.closest('[data-quick-add]');
      if (veil && e.target === veil && veil.classList.contains('is-open')) {
        closeAll();
        return;
      }

      const single = e.target.closest('[data-quick-single]');
      if (single) {
        e.preventDefault();
        add(single.closest('[data-quick-add]'), single.dataset.variantId);
        return;
      }

      const opener = e.target.closest('[data-quick-open]');
      if (opener) {
        e.preventDefault();
        const wrap = opener.closest('[data-quick-add]');
        const panel = wrap.querySelector('[data-quick-panel]');
        const wasOpen = wrap.classList.contains('is-open');
        closeAll();
        if (!wasOpen) {
          wrap.classList.add('is-open');
          if (panel) {
            /* Hace falta separar "mostrarlo" de "marcarlo visible", o el
               navegador ve un unico estado y no hay nada que animar.

               La separacion se hace leyendo una propiedad de layout, que fuerza
               el calculo en el acto, y NO con requestAnimationFrame: cuando la
               pestaña esta en segundo plano el navegador deja de producir
               fotogramas, la llamada nunca se ejecuta y el panel se queda
               abierto pero invisible -sin `is-shown` la opacidad es 0-. */
            panel.hidden = false;
            void panel.offsetHeight;
            panel.classList.add('is-shown');
          }
          opener.setAttribute('aria-expanded', 'true');
          /* La tarjeta .reveal conserva un transform mientras entra en pantalla,
             y un ancestro con transform convierte el position:fixed del panel en
             relativo a la tarjeta: la hoja se quedaba anclada a ella en vez de
             al borde inferior. Se neutraliza mientras el panel esta abierto. */
          const card = wrap.closest('.card');
          if (card) card.classList.add('is-quick-open');
          syncAvailability(wrap);
        }
        return;
      }

      const value = e.target.closest('[data-quick-value]');
      if (value) {
        e.preventDefault();
        const row = value.closest('[data-quick-row]');
        const wrap = value.closest('[data-quick-add]');
        row.querySelectorAll('[data-quick-value]').forEach(function (b) { b.classList.remove('is-active'); });
        value.classList.add('is-active');
        syncAvailability(wrap);
        return;
      }

      const confirm = e.target.closest('[data-quick-confirm]');
      if (confirm) {
        e.preventDefault();
        const wrap = confirm.closest('[data-quick-add]');
        const v = match(wrap);
        if (v && v.a) add(wrap, v.id);
        return;
      }

      /* El panel de filtros movil se excluye igual que el quick-add: es un panel
         propio, no un [data-panel], asi que closeAll() no lo cerraba pero si
         ejecutaba unlock(true), apagando el overlay y soltando el scroll del
         body con el panel todavia abierto. */
      if (!e.target.closest('[data-quick-add]') && !e.target.closest('[data-facet-side]')) closeAll();
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    /* ----- Selector de moneda -----
       Solo existe cuando hay mas de un mercado; con uno solo el snippet pinta
       una etiqueta estatica y aqui no hay nada que enganchar.

       document.querySelector y no el atajo $: ese vive en la primera IIFE del
       archivo y este bloque esta en otra. Usarlo aqui lanzaba un ReferenceError
       que, al no capturarse, abortaba el script entero y dejaba sin registrar
       todo lo que viene despues, incluidos los filtros de coleccion. */
    const curToggle = document.querySelector('[data-currency-toggle]');
    const curList = document.querySelector('[data-currency-list]');
    if (curToggle && curList) {
      function curOpen(open) {
        curList.hidden = !open;
        curToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      curToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        curOpen(curToggle.getAttribute('aria-expanded') !== 'true');
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-currency]')) curOpen(false);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') curOpen(false); });
    }
  });

  /* ---------- Collection filters ----------
     Filtrado sin recargar con la Section Rendering API, barra lateral con panel
     deslizante en movil, y control de precio de doble extremo. */
  mod('collection-filters', function () {
    const form = document.querySelector('[data-facet-form]');
    if (!form) return;

    const results = document.querySelector('[data-facet-results]');
    const side = document.querySelector('[data-facet-side]');
    const sectionId = form.dataset.sectionId;
    let pending = null;
    let debounce = null;

    /* ----- Panel lateral en movil ----- */
    function openSide() {
      if (!side) return;
      side.classList.add('is-open');
      if (window.MLlock) window.MLlock();
    }
    function closeSide() {
      if (!side) return;
      if (!side.classList.contains('is-open')) return;
      side.classList.remove('is-open');
      if (window.MLunlock) window.MLunlock();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-facet-side-open]')) { e.preventDefault(); openSide(); }
      if (e.target.closest('[data-facet-side-close]')) { e.preventDefault(); closeSide(); }
      if (side && side.classList.contains('is-open') &&
          !e.target.closest('[data-facet-side]') && !e.target.closest('[data-facet-side-open]')) {
        closeSide();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSide(); });
    const ov = document.querySelector('[data-overlay]');
    if (ov) ov.addEventListener('click', closeSide);

    /* ----- Control de precio de doble extremo -----
       Dos <input type="range"> superpuestos. Se impide que se crucen y se
       mantienen sincronizados con las casillas de texto en ambos sentidos. */
    function initPrice(scope) {
      (scope || document).querySelectorAll('[data-price-filter]').forEach(function (box) {
        if (box.dataset.priceReady) return;
        box.dataset.priceReady = '1';

        const rMin = box.querySelector('[data-price-range="min"]');
        const rMax = box.querySelector('[data-price-range="max"]');
        const fMin = box.querySelector('[data-price-field="min"]');
        const fMax = box.querySelector('[data-price-field="max"]');
        const fill = box.querySelector('[data-price-fill]');
        if (!rMin || !rMax) return;

        const ceil = Number(box.dataset.ceil) || 100;

        function paint() {
          const lo = Number(rMin.value);
          const hi = Number(rMax.value);
          if (fill) {
            fill.style.left = (lo / ceil) * 100 + '%';
            fill.style.width = ((hi - lo) / ceil) * 100 + '%';
          }
          /* Cuando las dos bolas coinciden, la de arriba tapa a la de abajo, y
             el maximo va despues en el HTML: manda el. Eso basta en el extremo
             izquierdo, donde el maximo todavia puede subir. Pegadas contra el
             tope derecho no, porque ahi el maximo no tiene hacia donde ir y la
             unica que puede moverse, la del minimo, queda debajo y no se puede
             agarrar. Solo en ese caso subimos el minimo. */
          rMin.style.zIndex = lo >= hi && hi >= ceil ? '4' : '';
        }

        function fromSlider(which) {
          let lo = Number(rMin.value);
          let hi = Number(rMax.value);
          if (lo > hi) {
            if (which === 'min') { lo = hi; rMin.value = lo; }
            else { hi = lo; rMax.value = hi; }
          }
          /* El campo vacio significa "sin limite": no escribimos 0 ni el maximo,
             asi la URL no se llena de parametros innecesarios. */
          if (fMin) fMin.value = lo > 0 ? lo : '';
          if (fMax) fMax.value = hi < ceil ? hi : '';
          paint();
        }

        function fromField() {
          const lo = fMin && fMin.value !== '' ? Math.max(0, Math.min(ceil, Number(fMin.value))) : 0;
          const hi = fMax && fMax.value !== '' ? Math.max(0, Math.min(ceil, Number(fMax.value))) : ceil;
          rMin.value = Math.min(lo, hi);
          rMax.value = Math.max(lo, hi);
          paint();
        }

        rMin.addEventListener('input', function () { fromSlider('min'); });
        rMax.addEventListener('input', function () { fromSlider('max'); });
        rMin.addEventListener('change', schedule);
        rMax.addEventListener('change', schedule);
        if (fMin) { fMin.addEventListener('input', fromField); fMin.addEventListener('change', schedule); }
        if (fMax) { fMax.addEventListener('input', fromField); fMax.addEventListener('change', schedule); }

        paint();
      });
    }

    /* ----- Filtrado ----- */
    function buildUrl() {
      const params = new URLSearchParams();
      for (const [k, v] of new FormData(form).entries()) {
        if (v !== '' && v !== null) params.append(k, v);
      }
      const sort = document.querySelector('[data-facet-sort]');
      if (sort && sort.value) { params.delete('sort_by'); params.append('sort_by', sort.value); }
      const qs = params.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    function openState() {
      return Array.from(form.querySelectorAll('.facet')).map((d) => d.open);
    }

    /* ----- Colores agrupados por color base -----
       El circulo grande no se envia (no tiene name): solo manda sobre las
       casillas reales de sus tonos. */
    function kidsOf(group) {
      return Array.from(group.querySelectorAll('[data-color-kids] input[type="checkbox"]'));
    }

    /* Marca o desmarca todos los tonos del grupo. Los agotados van deshabilitados
       y se dejan fuera: marcarlos daria una coleccion vacia. */
    function fromParent(parent) {
      const group = parent.closest('[data-color-group]');
      if (!group) return;
      kidsOf(group).forEach(function (k) { if (!k.disabled) k.checked = parent.checked; });
      if (parent.checked) openGroup(group, true);
    }

    /* Estado del padre a partir de los hijos: marcado si estan todos, a medias
       si solo algunos. */
    function syncParent(group) {
      const parent = group.querySelector('[data-color-parent]');
      if (!parent) return;
      const kids = kidsOf(group).filter(function (k) { return !k.disabled; });
      const on = kids.filter(function (k) { return k.checked; }).length;
      parent.checked = kids.length > 0 && on === kids.length;
      parent.indeterminate = on > 0 && on < kids.length;
    }

    function openGroup(group, open) {
      const kids = group.querySelector('[data-color-kids]');
      const toggle = group.querySelector('[data-color-toggle]');
      if (kids) kids.hidden = !open;
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function groupState() {
      return Array.from(form.querySelectorAll('[data-color-group]')).map(function (g) {
        const kids = g.querySelector('[data-color-kids]');
        return kids ? !kids.hidden : false;
      });
    }

    function syncAllParents() {
      form.querySelectorAll('[data-color-group]').forEach(syncParent);
    }

    function apply() {
      const url = buildUrl();
      const state = openState();
      const gstate = groupState();
      /* La casilla que se acaba de marcar se destruye al repintar el panel, y
         el foco caia a <body>: habia que tabular desde el principio de la
         pagina para poner el segundo filtro. Se guarda por nombre y valor, que
         es lo unico que sobrevive al reemplazo. */
      const act = document.activeElement;
      const refocus = act && act.name && act.form === form ? { name: act.name, value: act.value } : null;
      if (results) {
        results.classList.add('is-loading');
        results.setAttribute('aria-busy', 'true');
      }

      if (pending) pending.abort();
      const controller = new AbortController();
      pending = controller;

      fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + sectionId, { signal: controller.signal })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const newResults = doc.querySelector('[data-facet-results]');
          if (newResults && results) results.innerHTML = newResults.innerHTML;

          const newCount = doc.querySelector('[data-facet-count]');
          const count = document.querySelector('[data-facet-count]');
          if (newCount && count) count.textContent = newCount.textContent;

          /* Los contadores por valor cambian al filtrar. Se actualizan los
             paneles de lista, pero nunca el de precio: recrearlo cortaria el
             arrastre en curso. */
          const newPanels = Array.from(doc.querySelectorAll('.facet__panel'));
          const panels = Array.from(form.querySelectorAll('.facet__panel'));
          panels.forEach(function (panel, i) {
            if (panel.hasAttribute('data-price-filter')) return;
            if (newPanels[i] && !newPanels[i].hasAttribute('data-price-filter')) {
              panel.innerHTML = newPanels[i].innerHTML;
            }
          });

          /* La cabecera de cada grupo tambien: ahi vive el numerito de cuantos
             valores hay marcados, y al vivir en el <summary> y no en el panel se
             quedaba con lo que hubiera al cargar la pagina. El sintoma era que
             el contador solo aparecia al recargar con los filtros ya puestos.
             Aqui si se toca el de precio, porque cambiar el <summary> no
             interrumpe el arrastre, que esta en el panel. */
          const newToggles = Array.from(doc.querySelectorAll('.facet__toggle'));
          const toggles = Array.from(form.querySelectorAll('.facet__toggle'));
          toggles.forEach(function (toggle, i) {
            if (newToggles[i]) toggle.innerHTML = newToggles[i].innerHTML;
          });

          form.querySelectorAll('.facet').forEach((d, i) => { d.open = state[i]; });

          /* El panel se ha reescrito con el HTML del servidor, que trae los
             grupos cerrados. Se devuelve el desplegado que tenia el usuario y se
             recalculan los circulos base con los contadores nuevos. */
          form.querySelectorAll('[data-color-group]').forEach(function (g, i) {
            if (gstate[i] !== undefined) openGroup(g, gstate[i]);
          });
          syncAllParents();

          if (refocus) {
            const back = form.querySelector(
              'input[name="' + refocus.name.replace(/"/g, '\\"') + '"][value="' + refocus.value.replace(/"/g, '\\"') + '"]'
            );
            if (back) back.focus();
          }

          const newActive = doc.querySelector('[data-facet-active]');
          const active = document.querySelector('[data-facet-active]');
          if (active && newActive) active.innerHTML = newActive.innerHTML;
          else if (active && !newActive) active.remove();
          else if (!active && newActive && results) results.parentNode.insertBefore(newActive, results);

          history.replaceState({}, '', url);
          if (results) {
            results.classList.remove('is-loading');
            results.setAttribute('aria-busy', 'false');
            results.querySelectorAll('.reveal').forEach((n) => n.classList.add('is-in'));
          }
        })
        .catch((err) => {
          if (err.name === 'AbortError') return;
          if (results) {
            results.classList.remove('is-loading');
            results.setAttribute('aria-busy', 'false');
          }
          window.location.href = url;
        });
    }

    function schedule() {
      clearTimeout(debounce);
      debounce = setTimeout(apply, 320);
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-price-filter]')) return; // el precio tiene su propio disparador

      /* Antes de apply(), porque buildUrl() lee el formulario tal y como este en
         este momento: si los tonos se marcaran despues, la primera peticion iria
         sin ellos. */
      if (e.target.matches('[data-color-parent]')) {
        fromParent(e.target);
      } else {
        const group = e.target.closest('[data-color-group]');
        if (group) syncParent(group);
      }

      apply();
    });

    /* Abrir y cerrar la lista de tonos de un color base. */
    form.addEventListener('click', function (e) {
      const toggle = e.target.closest('[data-color-toggle]');
      if (!toggle) return;
      e.preventDefault();
      const group = toggle.closest('[data-color-group]');
      if (group) openGroup(group, toggle.getAttribute('aria-expanded') !== 'true');
    });

    syncAllParents();
    form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });

    const sortEl = document.querySelector('[data-facet-sort]');
    if (sortEl) sortEl.addEventListener('change', apply);

    /* Quitar un filtro activo sin recargar */
    document.addEventListener('click', function (e) {
      const chip = e.target.closest('[data-facet-active] a, [data-facet-clear]');
      if (!chip) return;
      e.preventDefault();
      const keep = new URLSearchParams(new URL(chip.href, window.location.origin).search);
      form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.checked = Array.from(keep.entries()).some(([k, v]) => k === cb.name && v === cb.value);
      });
      form.querySelectorAll('[data-price-filter]').forEach(function (box) {
        const fMin = box.querySelector('[data-price-field="min"]');
        const fMax = box.querySelector('[data-price-field="max"]');
        const rMin = box.querySelector('[data-price-range="min"]');
        const rMax = box.querySelector('[data-price-range="max"]');
        if (!keep.has(fMin && fMin.name)) { if (fMin) fMin.value = ''; if (rMin) rMin.value = 0; }
        if (!keep.has(fMax && fMax.name)) { if (fMax) fMax.value = ''; if (rMax) rMax.value = box.dataset.ceil; }
        const fill = box.querySelector('[data-price-fill]');
        if (fill && rMin && rMax) {
          const ceil = Number(box.dataset.ceil) || 100;
          fill.style.left = (Number(rMin.value) / ceil) * 100 + '%';
          fill.style.width = ((Number(rMax.value) - Number(rMin.value)) / ceil) * 100 + '%';
        }
      });
      apply();
    });

    initPrice();
    document.addEventListener('shopify:section:load', function (e) { initPrice(e.target); });
  });

  /* ---------- Vista previa de color en la tarjeta ----------
     Al pasar el cursor por un swatch (o tocarlo en movil) la foto principal de
     la tarjeta pasa a ser la de esa variante, sin entrar en el producto.
     Va en su propio bloque y no dentro del de filtros: aquel sale antes si la
     pagina no tiene formulario de facetas, y las tarjetas tambien estan en la
     portada y en el buscador. Los eventos se delegan en document para que
     sigan vivos tras un refresco de filtros, que sustituye el HTML. */
  mod('card-swatches', function () {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function show(sw) {
      const card = sw.closest('.card');
      if (!card) return;
      const img = card.querySelector('.card__img--1');
      const src = sw.getAttribute('data-card-swatch');
      if (!img || !src) return;

      /* La foto de catalogo se guarda una sola vez para poder restaurarla. */
      if (img.dataset.baseSrc === undefined) {
        img.dataset.baseSrc = img.getAttribute('src') || '';
        img.dataset.baseSrcset = img.getAttribute('srcset') || '';
      }

      img.setAttribute('src', src);
      const set = sw.getAttribute('data-card-swatch-srcset');
      if (set) img.setAttribute('srcset', set);
      else img.removeAttribute('srcset');

      card.classList.add('is-swatch-preview');
      card.querySelectorAll('.card__swatch.is-active').forEach(function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
    }

    function reset(card) {
      if (!card || !card.classList.contains('is-swatch-preview')) return;
      const img = card.querySelector('.card__img--1');
      if (img && img.dataset.baseSrc !== undefined) {
        img.setAttribute('src', img.dataset.baseSrc);
        if (img.dataset.baseSrcset) img.setAttribute('srcset', img.dataset.baseSrcset);
        else img.removeAttribute('srcset');
      }
      card.classList.remove('is-swatch-preview');
      card.querySelectorAll('.card__swatch.is-active').forEach(function (s) { s.classList.remove('is-active'); });
    }

    if (canHover) {
      document.addEventListener('mouseover', function (e) {
        const sw = e.target.closest('[data-card-swatch]');
        if (sw) show(sw);
      });
      /* Solo al abandonar la tarjeta entera se vuelve a la foto de catalogo:
         asi se puede recorrer la fila de colores sin parpadeos. */
      document.addEventListener('mouseout', function (e) {
        const card = e.target.closest('.card');
        if (!card) return;
        if (e.relatedTarget && card.contains(e.relatedTarget)) return;
        reset(card);
      });
    }

    /* Tactil: el swatch es un <button>, asi que pulsarlo no navega. Se muestra
       la variante, y una segunda pulsacion sobre el mismo color deshace. */
    document.addEventListener('click', function (e) {
      const sw = e.target.closest('[data-card-swatch]');
      if (!sw) return;
      e.preventDefault();
      if (sw.classList.contains('is-active')) reset(sw.closest('.card'));
      else show(sw);
    });
  });

  /* ---------------- Resenas: carrusel infinito ----------------
     Una marquesina, no un carrusel paginado: avanza sola sin parar y no tiene
     principio ni final. Se apoya en el scroll nativo del contenedor en vez de
     en un transform, para que arrastrar con el dedo sea el gesto del navegador
     de toda la vida: se puede frenar, empujar mas rapido o tirar hacia atras
     sin escribir ni una linea de gestos.

     El truco del bucle es clonar las tarjetas hasta tener varias vueltas
     seguidas y saltar de una a otra cuando se cruza el limite. Como el
     contenido de cada vuelta es identico, el salto no se ve. */
  mod('review-marquee', function () {
    'use strict';

    /* Este carrusel no atiende a prefers-reduced-motion. Es una decision del
       usuario, tomada sabiendo lo que implica: en Windows basta con tener
       apagadas las animaciones del sistema para que el navegador lo pida, y
       con eso la seccion se quedaba muerta en la mayoria de los equipos de la
       tienda. El movimiento es lento y horizontal, y siempre se puede parar
       poniendo el raton encima o el dedo sobre el carril. */

    function init(root) {
      if (root.dataset.marqueeReady) return;
      const track = root.querySelector('[data-marquee-track]');
      if (!track) return;
      const originals = Array.from(track.children);
      if (!originals.length) return;
      root.dataset.marqueeReady = '1';

      const speed = parseFloat(root.dataset.speed) || 35;

      /* Se clona hasta cubrir tres anchos de pantalla: hace falta una vuelta
         delante y otra detras para que se pueda arrastrar en ambos sentidos sin
         chocar con el tope del scroll. */
      let cycle = 0;
      function build() {
        Array.from(track.children).forEach(function (n, i) {
          if (i >= originals.length) n.remove();
        });
        let guard = 0;
        while ((track.scrollWidth < track.clientWidth * 3 || track.children.length < originals.length * 3) && guard < 30) {
          originals.forEach(function (n) {
            const copy = n.cloneNode(true);
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('a, button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
            track.appendChild(copy);
          });
          guard++;
        }
        const first = track.children[0];
        const nextRound = track.children[originals.length];
        cycle = nextRound ? nextRound.offsetLeft - first.offsetLeft : track.scrollWidth;
        if (cycle > 0) { track.scrollLeft = cycle; pos = cycle; }
      }

      /* La posicion se lleva aparte y con decimales. scrollLeft se redondea a
         pixeles enteros, asi que sumarle el avance de cada fotograma se pierde
         en cuanto la pantalla va rapida: a 60 Hz toca ~1px por fotograma y
         cuela, pero a 172 Hz toca 0,36px, que al redondear es cero, y el carril
         se queda clavado. Por eso funcionaba en el movil y no en los equipos de
         sobremesa. Guardando el resto aqui, el avance llega igual aunque cada
         fotograma aporte menos de un pixel. */
      let pos = 0;
      let paused = false;
      let visible = true;
      let last = 0;
      let raf;
      let lastScroll = -1;
      let stillFrames = 0;
      /* Aqui arriba y no junto a los manejadores tactiles: frame() lo lee, y
         una declaracion posterior lo dejaria en zona muerta temporal. */
      let settleUntil = 0;

      build();

      function wrap() {
        if (cycle <= 0) return;
        if (pos >= cycle * 2) { pos -= cycle; track.scrollLeft = pos; }
        else if (pos <= 0) { pos += cycle; track.scrollLeft = pos; }
      }

      function frame(now) {
        const dt = last ? Math.min(now - last, 100) : 0;
        last = now;
        /* no-scroll lo pone cualquier cosa que abra una capa por encima: el
           visor de fotos, el carrito, el panel de filtros. Sin esta condicion
           el carril seguia corriendo detras del visor, y como abrirlo saca el
           puntero del carril, el pointerleave lo reanudaba justo al pulsar las
           flechas para pasar de foto. */
        const blocked = document.body.classList.contains('no-scroll');

        /* Asentamiento tras el dedo: se sale en cuanto scrollLeft se queda
           quieto tres fotogramas, o al agotarse el plazo por si el navegador
           deja un desplazamiento residual que nunca cuadra al pixel. */
        if (settleUntil) {
          const sl = Math.round(track.scrollLeft);
          if (sl === lastScroll) { stillFrames++; } else { stillFrames = 0; lastScroll = sl; }
          if (stillFrames >= 3 || now > settleUntil) { settleUntil = 0; stillFrames = 0; }
        }

        if (!paused && !settleUntil && visible && !blocked) {
          pos += (speed * dt) / 1000;
          track.scrollLeft = pos;
        } else {
          /* Parado o arrastrando manda el scroll real, que es el que ha tocado
             el visitante; si no, al soltar volveria de un salto a donde estaba
             la posicion guardada. */
          pos = track.scrollLeft;
        }
        wrap();
        raf = requestAnimationFrame(frame);
      }

      function startLoop() {
        if (raf) return;
        /* last a cero y pos releido: al volver a pantalla el primer dt no debe
           arrastrar todo el tiempo que la seccion estuvo parada. */
        last = 0;
        pos = track.scrollLeft;
        raf = requestAnimationFrame(frame);
      }
      function stopLoop() {
        if (!raf) return;
        cancelAnimationFrame(raf);
        raf = 0;
      }
      startLoop();

      /* Mientras el dedo o el raton estan encima se para: es lo que permite
         leer una resena entera sin que se escape. pointercancel entra aqui
         porque en cuanto el navegador se queda el gesto para hacer scroll deja
         de mandar pointerup. */
      const hold = function () { paused = true; };
      const release = function () { paused = false; };

      /* Soltar el dedo NO es lo mismo que soltar el raton. El navegador sigue
         desplazando el carril por inercia hasta un segundo despues del
         touchend, y si el bucle se reanuda ya, en el siguiente fotograma
         escribe scrollLeft = pos y mata el impulso: se flica y se queda clavado
         donde se levanto el dedo. Se marca un periodo de asentamiento en el que
         el bucle mira pero no toca, y termina en cuanto el scroll deja de
         moverse solo. */
      const releaseTouch = function () {
        settleUntil = performance.now() + 1200;
        paused = false;
      };
      /* La pausa al pasar por encima solo en equipos con raton de verdad. En un
         hibrido o en un movil que emula hover, un pointerenter suelto dejaba el
         carril parado para siempre porque el pointerleave correspondiente no
         llegaba nunca. */
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        track.addEventListener('pointerenter', hold);
        track.addEventListener('pointerleave', release);
      }
      track.addEventListener('pointercancel', release);
      track.addEventListener('touchstart', hold, { passive: true });
      track.addEventListener('touchend', releaseTouch, { passive: true });
      track.addEventListener('touchcancel', releaseTouch, { passive: true });
      /* Y con el teclado: si alguien tabula hasta un enlace de dentro, que no
         se lo lleve la corriente. */
      track.addEventListener('focusin', hold);
      track.addEventListener('focusout', release);

      /* Arrastre con el raton. En tactil no hace falta porque el navegador ya
         desplaza el contenedor solo, pero con raton un contenedor con overflow
         no se arrastra: el gesto selecciona texto. Aqui se mueve scrollLeft a
         mano. */
      let dragging = false;
      let moved = false;
      let startX = 0;
      let startScroll = 0;

      /* Sin setPointerCapture. Capturar el puntero hace que el navegador
         entregue el click al elemento que captura, o sea al carril, en vez de a
         la miniatura o al enlace que hay debajo: dejaba la seccion entera sin
         poder pulsarse con el raton, y solo funcionaba el boton central porque
         ese no pasa por aqui. El seguimiento se hace en window, que cubre
         igual de bien el caso de soltar fuera del carril. */
      track.addEventListener('pointerdown', function (e) {
        paused = true;
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      });

      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        const dx = e.clientX - startX;
        /* Hasta tres pixeles se considera un clic tembloroso, no un arrastre:
           asi pulsar no mueve el carril ni un poco. */
        if (!moved && Math.abs(dx) < 3) return;
        moved = true;
        track.classList.add('is-dragging');
        track.scrollLeft = startScroll - dx;
        e.preventDefault();
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        moved = false;
        track.classList.remove('is-dragging');
        paused = false;
      }
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);

      /* Aqui habia un guardian que se comia el clic si el puntero se habia
         movido mas de unos pixeles, para que soltar un arrastre encima de una
         miniatura no abriera la foto. Con un raton de verdad casi cualquier
         clic mueve dos o tres pixeles, asi que se estaba tragando tambien los
         clics buenos y en escritorio no habia forma de ampliar ninguna foto.
         Abrir una foto sin querer al terminar un arrastre es mucho menos grave
         que no poder abrirla nunca, asi que el guardian se ha quitado. */

      /* El observador se guarda en una variable, se leen todas las entradas y
         no solo la primera, y se le da un margen generoso para que la seccion
         cuente como visible un poco antes de asomar. Antes se creaba suelto y
         leyendo entries[0], que con varias entradas encoladas podia dejar
         'visible' en false con la seccion ya en pantalla. */
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.target !== root) return;
            visible = en.isIntersecting;
            /* Fuera de pantalla se detiene el bucle del todo. Antes seguia
               girando y leyendo scrollLeft sesenta veces por segundo para
               nada, que es una lectura de layout por fotograma. */
            if (visible) startLoop();
            else stopLoop();
          });
        }, { rootMargin: '300px 0px' });
        io.observe(root);
        root._marqueeIO = io;
      }

      /* Sondas para poder diagnosticar sin abrir las herramientas: dicen por que
         esta parado el carril en un momento dado. */
      root.marqueeState = function () {
        return { paused: paused, visible: visible, dragging: dragging, cycle: cycle,
                 blocked: document.body.classList.contains('no-scroll'),
                 scrollLeft: Math.round(track.scrollLeft), speed: speed };
      };

      /* Solo se reconstruye si cambia el ancho. En Chrome para Android,
         esconder y mostrar la barra de direcciones al hacer scroll dispara
         resize, y reconstruir el carril a mitad de gesto es justo el tipo de
         tiron que penaliza la respuesta al scroll. */
      let resizeTimer;
      let lastWidth = window.innerWidth;
      const onResize = function () {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(build, 200);
      };
      window.addEventListener('resize', onResize);

      /* El editor de temas entrega un DOM nuevo sin el flag de arriba, asi que
         sin esto cada recarga de la seccion dejaba el bucle anterior corriendo
         sobre un carril ya desprendido: diez ajustes, diez bucles. */
      root._marqueeTeardown = function () {
        stopLoop();
        clearTimeout(resizeTimer);
        window.removeEventListener('resize', onResize);
        if (root._marqueeIO) root._marqueeIO.disconnect();
      };
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-marquee]').forEach(init);
    }
    function teardown(scope) {
      (scope || document).querySelectorAll('[data-marquee]').forEach(function (root) {
        if (root._marqueeTeardown) root._marqueeTeardown();
      });
    }
    boot();
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
  });

  /* ---------------- Videos de portada: arranque al entrar en pantalla ----
     El atributo autoplay del HTML no se usa: combinado con preload="metadata"
     Chrome no llega a cargar el archivo y se queda el poster congelado. Aqui
     se llama a play() cuando el video entra en el viewport, que ademas evita
     descargar varios MB a quien nunca baja hasta la seccion.

     Se pausa al salir de pantalla para no gastar bateria decodificando algo
     que nadie esta viendo. Son mudos, asi que no hay nada que interrumpir. */
  /* ---------------- Tramos de descuento: marcar el que se aplica ----------
     La ficha de producto se renderiza una vez, pero la bolsa cambia por AJAX y
     solo se repintan la cabecera y el carrito. Sin esto, anadir un segundo
     vestido no marcaba el tramo en la ficha hasta recargar.

     Quien cuenta es el servidor: saber si algo es un vestido exige mirar sus
     colecciones, y eso solo se puede en Liquid. cart-summary publica el
     recuento en un data-vol-count y se re-renderiza con cada cambio, asi que
     aqui solo hay que leerlo y repintar. */
  mod('volume-tiers', function () {
    const list = $('[data-vol-list]');
    if (!list) return;

    const rows = $$('[data-vol-qty]', list);
    if (!rows.length) return;

    function sync() {
      const marker = $('[data-vol-count]');
      /* Sin marcador, la bolsa esta vacia: el estado vacio del cajon no
         incluye el resumen. */
      const count = marker ? parseInt(marker.getAttribute('data-vol-count'), 10) || 0 : 0;

      let best = 0;
      rows.forEach(function (row) {
        const qty = parseInt(row.getAttribute('data-vol-qty'), 10) || 0;
        if (count >= qty && qty > best) best = qty;
      });

      rows.forEach(function (row) {
        const qty = parseInt(row.getAttribute('data-vol-qty'), 10) || 0;
        const on = best > 0 && qty === best;
        row.classList.toggle('is-active', on);
        const flag = row.querySelector('.vol__flag');
        if (flag) flag.hidden = !on;
      });
    }

    sync();
    document.addEventListener('cart:updated', sync);
  });

  mod('hero-videos', function () {
    'use strict';

    const autos = document.querySelectorAll('[data-video-auto]');
    if (!autos.length) return;

    /* Estos videos NO se paran con prefers-reduced-motion, por el mismo motivo
       que el carrusel de resenas: en Windows basta con apagar las animaciones
       del sistema -algo que mucha gente hace por rendimiento, no por
       sensibilidad al movimiento- para que Chrome reporte la preferencia. Con
       la comprobacion puesta, la portada se quedaba en negro en los cuatro
       equipos del usuario.

       El poster va como atributo real, no diferido: garantiza que siempre haya
       algo que mirar aunque el video tarde o no llegue a reproducirse. */
    function play(v) {
      v.muted = true;
      const p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      autos.forEach(play);
      return;
    }

    /* Dos fases, y el orden importa.

       El HTML trae preload="none" para que quien no baje hasta aqui no se
       descargue nada. Pero con eso a secas la descarga no arrancaba hasta el
       play(), o sea hasta tener el video ya en pantalla: se veia el poster
       fijo un buen rato antes de que se moviera.

       Asi que se calienta antes: a 800px de asomar se pasa a preload auto y se
       pide la carga, de modo que al llegar ya haya datos suficientes para
       arrancar sin espera. Sigue sin costar nada a quien no llega. */
    const warm = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        const v = en.target;
        warm.unobserve(v);
        if (v.preload === 'auto') return;
        v.preload = 'auto';
        /* load() reinicia el elemento, asi que solo si no ha empezado ya:
           si se llega de golpe -un ancla, o recargar a media pagina- las dos
           fases pueden coincidir en el mismo tick. */
        if (v.readyState === 0 && v.paused) v.load();
      });
    }, { rootMargin: '800px 0px' });

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play(entry.target);
        else entry.target.pause();
      });
    }, { threshold: 0.25 });

    autos.forEach(function (v) { warm.observe(v); io.observe(v); });
  });

  /* ---------------- Visor de fotos de resena ----------------
     Las miniaturas son <button> con la URL grande en data-full. El visor se
     crea una sola vez y a la primera apertura, para no meter markup vacio en
     todas las paginas que no tienen resenas. */
  mod('review-lightbox', function () {
    'use strict';

    let box, stage, prevBtn, nextBtn;
    let photos = [];
    let index = 0;
    let lastTrigger = null;

    function build() {
      if (box) return;
      box = document.createElement('div');
      box.className = 'rev-lb';
      /* Se anuncia como dialogo y retiene el foco dentro: antes el visor se
         abria a pantalla completa y el tabulador seguia recorriendo la pagina
         de detras, invisible bajo la capa negra. */
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Review photo');
      box.innerHTML =
        '<button type="button" class="rev-lb__close" aria-label="Close">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<button type="button" class="rev-lb__nav rev-lb__nav--prev" aria-label="Previous">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M15 6l-6 6 6 6"/></svg>' +
        '</button>' +
        '<img alt="">' +
        '<button type="button" class="rev-lb__nav rev-lb__nav--next" aria-label="Next">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M9 6l6 6-6 6"/></svg>' +
        '</button>';
      document.body.appendChild(box);

      stage = box.querySelector('img');
      prevBtn = box.querySelector('.rev-lb__nav--prev');
      nextBtn = box.querySelector('.rev-lb__nav--next');

      box.querySelector('.rev-lb__close').addEventListener('click', close);
      prevBtn.addEventListener('click', function () { go(index - 1); });
      nextBtn.addEventListener('click', function () { go(index + 1); });
      /* Pinchar el fondo cierra; pinchar la foto o los botones, no. */
      box.addEventListener('click', function (e) { if (e.target === box) close(); });
    }

    function go(n) {
      if (!photos.length) return;
      index = (n + photos.length) % photos.length;
      stage.src = photos[index].src;
      /* El alt viaja desde la miniatura. Antes la imagen se creaba con alt
         vacio, asi que el visor anunciaba un dialogo con una foto sin nombre. */
      stage.alt = photos[index].alt || '';
      const many = photos.length > 1;
      prevBtn.hidden = !many;
      nextBtn.hidden = !many;
    }

    function close() {
      if (!box) return;
      box.classList.remove('is-open');
      if (window.MLunlock) window.MLunlock();
      /* Devolver el foco a la miniatura que abrio el visor: si no, queda en un
         boton que ya no se ve y el usuario pierde su sitio en la pagina. */
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      lastTrigger = null;
    }

    document.addEventListener('click', function (e) {
      const thumb = e.target.closest('[data-review-photo]');
      if (!thumb) return;
      e.preventDefault();

      /* Las fotos hermanas alimentan las flechas, para poder pasar de una a
         otra sin cerrar y volver a abrir. */
      const group = thumb.closest('.rev-card__thumbs');
      const buttons = group ? Array.from(group.querySelectorAll('[data-review-photo]')) : [thumb];
      photos = buttons.map(function (b) {
        const img = b.querySelector('img');
        return { src: b.dataset.full, alt: img ? img.alt : '' };
      });

      lastTrigger = thumb;
      build();
      go(buttons.indexOf(thumb));
      box.classList.add('is-open');
      if (window.MLlock) window.MLlock();
      box.querySelector('.rev-lb__close').focus();
    });

    document.addEventListener('keydown', function (e) {
      if (!box || !box.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowLeft') { go(index - 1); return; }
      if (e.key === 'ArrowRight') { go(index + 1); return; }
      if (e.key !== 'Tab') return;
      /* Ciclo cerrado entre los controles visibles del visor. prevBtn y nextBtn
         se ocultan con una sola foto, y un elemento hidden no es enfocable, asi
         que se filtran aqui en vez de listarlos a mano. */
      const stops = Array.from(box.querySelectorAll('button')).filter(function (b) { return !b.hidden; });
      if (!stops.length) return;
      const first = stops[0];
      const last = stops[stops.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    });
  });
  /* ---------------- Pop-up de bienvenida ----------------
     Correo a cambio de un codigo de descuento.

     Reemplaza al de Klaviyo, que dependia de `a.klaviyo.com` -su dominio de
     rastreo, presente en casi toda lista de bloqueo- y fallaba al enviar en
     cuanto el visitante usaba un DNS filtrante o una extension.

     POR QUE SE ENVIA A LA MANERA CLASICA Y NO POR FETCH:
     Shopify protege los formularios de cliente con captcha invisible. El token
     lo inyecta su propio script al enviar el <form>, y no hay API publica para
     pedirlo desde JavaScript. Un envio por fetch, por bien construido que este,
     recibe `400 Missing CAPTCHA token` -comprobado en produccion-. Asi que se
     deja enviar de forma nativa, con su recarga, y el paso del codigo se pinta
     al volver: Shopify redirige a la misma pagina con ?customer_posted=true.

     Para contar: el alta etiqueta al cliente con `welcome-popup`, asi que las
     suscripciones se cuentan exactas filtrando por esa etiqueta en Clientes. */
  mod('welcome-popup', function () {
    const root = $('[data-wpop]');
    if (!root) return;

    const box = $('[data-wpop-box]', root);
    const form = $('#WpopForm', root);
    const email = $('[data-wpop-email]', root);
    const submit = $('[data-wpop-submit]', root);
    const submitLabel = $('[data-wpop-submit-label]', root);
    const errorBox = $('[data-wpop-error]', root);
    const serverError = $('[data-wpop-server-error]', root);
    const stepOffer = $('[data-wpop-step="offer"]', root);
    const stepDone = $('[data-wpop-step="done"]', root);
    if (!box || !form || !email) return;

    let strings = {};
    try {
      const raw = $('[data-wpop-strings]');
      if (raw) strings = JSON.parse(raw.textContent);
    } catch (e) { /* los textos por defecto de abajo bastan */ }

    const SNOOZE_KEY = 'ml_wpop_snoozed_until';
    const DONE_KEY = 'ml_wpop_subscribed';
    const PENDING_KEY = 'ml_wpop_pending';
    const delay = parseInt(root.getAttribute('data-wpop-delay'), 10);
    const snoozeDays = parseInt(root.getAttribute('data-wpop-snooze'), 10) || 2;

    /* En incognito estricto el almacenamiento lanza al escribir. Se degrada a
       "no recordar nada" en vez de romper: mejor un pop-up de mas que un error
       que se lleve por delante el modulo entero. */
    function readStore(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    }
    function writeStore(key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) { /* sin memoria */ }
    }

    /* La vuelta del envio se reconoce con dos senales a la vez: el parametro que
       pone Shopify y una marca de sesion que dejamos nosotros al enviar. Hacen
       falta las dos, porque ese parametro tambien aparece cuando alguien se
       suscribe por el formulario del pie, y ahi el pop-up no pinta nada. */
    let pending = false;
    try {
      pending = window.sessionStorage.getItem(PENDING_KEY) === '1';
      if (pending) window.sessionStorage.removeItem(PENDING_KEY);
    } catch (e) { /* sin sesion, no hay vuelta que reconocer */ }

    const posted = /[?&]customer_posted=true/.test(window.location.search);
    const returning = pending && (posted || !!serverError);

    /* En el Personalizador siempre se enseña y se ignora lo recordado: si no,
       quien lo esta editando no vuelve a verlo tras cerrarlo una vez. Y con
       ?popup=1 se fuerza en la tienda de verdad, que es como se prueba sin
       esperar los 30 segundos ni borrar nada. */
    const forced = /[?&]popup=1\b/.test(window.location.search);
    const designMode = !!(window.Shopify && window.Shopify.designMode);
    const bypass = forced || designMode || returning;

    function suppressed() {
      if (bypass) return false;
      if (readStore(DONE_KEY)) return true;
      const until = parseInt(readStore(SNOOZE_KEY), 10);
      return !!until && Date.now() < until;
    }
    if (suppressed()) return;

    /* Se avisa a los pixeles que haya. Cada uno por su cuenta y en try: que
       falte Meta no puede impedir que se registre en GA4, ni al reves. */
    function track(name) {
      try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name); } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', name); } catch (e) {}
      try { if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name }); } catch (e) {}
    }

    /* Se limpia ?customer_posted=true de la barra para que al recargar o
       compartir el enlace no se repita el paso del codigo sin haberse dado de
       alta. Solo la barra: no se navega ni se pierde el desplazamiento. */
    function cleanUrl() {
      if (!window.history || !window.history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('popup');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    let lastFocus = null;

    function open() {
      if (!root.hidden) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      /* Un fotograma entre quitar `hidden` y poner la clase: sin el, el
         navegador aplica ambos estados a la vez y no hay transicion que animar. */
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      if (window.MLlock) window.MLlock();
      track('WelcomePopupShown');
      const onDone = stepDone && !stepDone.hidden;
      const focusTarget = onDone ? $('[data-wpop-copy]', root) : email;
      if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
    }

    function close() {
      if (root.hidden) return;
      root.classList.remove('is-open');
      /* Solo se apunta el aplazamiento si aun no se ha dado de alta: a quien ya
         tiene su codigo lo tapa DONE_KEY, que no caduca. */
      if (!readStore(DONE_KEY)) {
        writeStore(SNOOZE_KEY, String(Date.now() + snoozeDays * 86400000));
      }
      setTimeout(function () {
        root.hidden = true;
        if (window.MLunlock) window.MLunlock();
        if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
      }, 320);
    }

    $$('[data-wpop-close]', root).forEach(function (b) {
      b.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || root.hidden) return;
      /* Si hay algo abierto por encima -la busqueda, un menu- manda ese. */
      if (document.querySelector('.search-panel.is-open, .mobile-nav.is-open')) return;
      close();
    });

    /* Trampa de foco: con el fondo bloqueado, tabular fuera del dialogo lleva a
       enlaces que no se ven y no se puede volver. */
    box.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      const stops = Array.from(box.querySelectorAll('button, input, a[href]')).filter(function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
      if (!stops.length) return;
      const first = stops[0];
      const last = stops[stops.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    });

    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg;
      errorBox.hidden = false;
    }

    function showDone() {
      if (stepOffer) stepOffer.hidden = true;
      if (stepDone) stepDone.hidden = false;
    }

    /* Solo se comprueba lo evidente antes de gastar una recarga entera: que haya
       algo con arroba y un punto detras. Lo demas lo dice Shopify al volver. */
    form.addEventListener('submit', function (e) {
      const value = (email.value || '').trim();
      if (!value || value.indexOf('@') < 1 || value.indexOf('.', value.indexOf('@')) < 0) {
        e.preventDefault();
        showError(strings.email || 'Please enter a valid email address.');
        email.focus();
        return;
      }
      if (errorBox) errorBox.hidden = true;

      /* La marca de sesion es lo que permite reconocer la vuelta como nuestra y
         no como un alta desde el pie. */
      try { window.sessionStorage.setItem(PENDING_KEY, '1'); } catch (err) { /* da igual */ }

      /* El boton se apaga en el siguiente turno, no ahora: desactivarlo dentro
         del propio manejador puede llegar a cancelar el envio en marcha. */
      setTimeout(function () {
        submit.disabled = true;
        if (submitLabel) submitLabel.textContent = '…';
      }, 0);
    });

    /* Copiar al portapapeles. La API moderna necesita contexto seguro y permiso;
       si no esta, se recurre a seleccionar el texto y execCommand, que es viejo
       pero sigue funcionando donde la otra no llega. */
    const copyBtn = $('[data-wpop-copy]', root);
    const codeEl = $('[data-wpop-code]', root);
    if (copyBtn && codeEl) {
      const copyLabel = $('[data-wpop-copy-label]', copyBtn);
      let restore = null;

      const flash = function () {
        copyBtn.classList.add('is-copied');
        if (copyLabel) copyLabel.textContent = strings.copied || 'Copied';
        clearTimeout(restore);
        restore = setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          if (copyLabel) copyLabel.textContent = strings.copy || 'Copy code';
        }, 2200);
      };

      const legacyCopy = function (text) {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        let ok = false;
        try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
        document.body.removeChild(ta);
        return ok;
      };

      copyBtn.addEventListener('click', function () {
        const text = (codeEl.textContent || '').trim();
        if (!text) return;
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(text).then(flash, function () {
            if (legacyCopy(text)) flash();
          });
        } else if (legacyCopy(text)) {
          flash();
        }
      });
    }

    /* ---- Arranque ---- */
    if (returning && posted) {
      /* Alta confirmada por Shopify: se marca como suscrito, se pinta el codigo
         y se abre ya en ese paso. */
      writeStore(DONE_KEY, '1');
      track('WelcomePopupSubscribed');
      showDone();
      cleanUrl();
      open();
    } else if (returning) {
      /* Volvio con error -correo rechazado por Shopify-. El mensaje lo pinta
         Liquid dentro del formulario; aqui solo hay que volver a abrirlo para
         que se lea, sin perder lo que quedo escrito. */
      cleanUrl();
      open();
    } else if (bypass) {
      open();
    } else {
      /* El retraso cuenta tiempo con la pestaña delante. Quien abre la tienda en
         segundo plano y vuelve al cabo de un rato no se merece el pop-up en la
         cara nada mas mirar. */
      let waited = 0;
      const target = isNaN(delay) ? 30 : delay;
      const tick = setInterval(function () {
        if (document.visibilityState !== 'visible') return;
        waited++;
        if (waited >= target) {
          clearInterval(tick);
          open();
        }
      }, 1000);
    }
  });
  /* ---------------- Copiar un codigo al portapapeles ----------------
     Sirve a cualquier pareja "texto + boton" marcada con [data-copy-source] y
     [data-copy] dentro de un mismo contenedor.

     Va delegado en document en vez de recorrer botones al arrancar: la ficha de
     producto se repinta entera al cambiar de variante y al recargar la seccion
     desde el Personalizador, y un listener por boton se perderia en cada
     repintado. */
  mod('copy-code', function () {
    let restore = null;

    function legacyCopy(text) {
      /* La API moderna exige contexto seguro y permiso concedido. Donde no
         llega, seleccionar y execCommand sigue funcionando: es viejo, pero es
         lo unico que queda. */
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      let ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      return ok;
    }

    function flash(btn) {
      const label = btn.querySelector('.promo__copy-text') || btn;
      const original = btn.getAttribute('data-copy-was') || label.textContent;
      btn.setAttribute('data-copy-was', original);
      label.textContent = btn.getAttribute('data-copy-done') || 'Copied';
      btn.classList.add('is-copied');
      clearTimeout(restore);
      restore = setTimeout(function () {
        btn.classList.remove('is-copied');
        label.textContent = original;
      }, 2200);
    }

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-copy]');
      if (!btn) return;
      const holder = btn.closest('.promo') || btn.parentElement;
      const src = holder ? holder.querySelector('[data-copy-source]') : null;
      const text = src ? (src.textContent || '').trim() : '';
      if (!text) return;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(
          function () { flash(btn); },
          function () { if (legacyCopy(text)) flash(btn); }
        );
      } else if (legacyCopy(text)) {
        flash(btn);
      }
    });
  });
  /* ---------------- Guia de tallas ----------------
     Dos cosas: el interruptor de centimetros/pulgadas y el resaltado de la fila
     que corresponde a la talla elegida.

     Lo del resaltado es lo que mas rinde. Una tabla de siete columnas por cinco
     filas son treinta y cinco numeros, y quien la abre necesita seis: los de su
     talla, que ya ha elegido antes de pulsar "Size guide". */
  mod('size-table', function () {
    const UNIT_KEY = 'ml_size_unit';

    /* ---- Unidades ---- */
    function readUnit() {
      try {
        const v = window.localStorage.getItem(UNIT_KEY);
        return v === 'in' ? 'in' : 'cm';
      } catch (e) { return 'cm'; }
    }
    function writeUnit(u) {
      try { window.localStorage.setItem(UNIT_KEY, u); } catch (e) { /* sin memoria */ }
    }

    function applyUnit(unit) {
      $$('[data-size-table]').forEach(function (wrap) {
        wrap.setAttribute('data-unit', unit);
        $$('[data-unit-btn]', wrap).forEach(function (b) {
          const on = b.getAttribute('data-unit-btn') === unit;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    }

    /* La eleccion se recuerda entre productos y entre visitas: quien piensa en
       pulgadas lo hace en todas las fichas, no solo en la primera. */
    applyUnit(readUnit());

    /* Delegado en document porque la ficha se repinta entera al cambiar de
       variante y al recargar la seccion desde el Personalizador. */
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-unit-btn]');
      if (!btn) return;
      const unit = btn.getAttribute('data-unit-btn') === 'in' ? 'in' : 'cm';
      writeUnit(unit);
      applyUnit(unit);
    });

    /* ---- Resaltar la talla elegida ---- */

    /* La talla vive en el grupo de variantes que lleva el boton de la guia: es
       el unico sitio donde el marcado dice cual de las opciones ES la talla, y
       lo hace ya resuelto por Liquid, sin repetir aqui la heuristica del nombre
       de la opcion. */
    function currentSize() {
      const btn = $('.size-guide-btn');
      if (!btn) return '';
      const group = btn.closest('.variant-group');
      if (!group) return '';
      const value = $('[data-selected-value]', group);
      if (!value) return '';
      return (value.textContent || '').trim().toUpperCase().replace(/\s+/g, '');
    }

    function highlight() {
      const size = currentSize();
      $$('[data-size-table] tbody tr').forEach(function (tr) {
        const own = (tr.getAttribute('data-size-row') || '').toUpperCase();
        tr.classList.toggle('is-current', !!size && own === size);
      });
    }

    highlight();

    /* No hay un evento propio de cambio de variante en el que apoyarse, y
       escuchar los clics del selector obligaria a esperar a que el otro modulo
       termine de repintar. Se observa directamente el texto que muestra la
       talla: cambie quien lo cambie y cuando lo cambie, aqui llega. */
    const anchor = $('.size-guide-btn');
    const group = anchor ? anchor.closest('.variant-group') : null;
    const label = group ? $('[data-selected-value]', group) : null;
    if (label && window.MutationObserver) {
      new MutationObserver(highlight).observe(label, { childList: true, characterData: true, subtree: true });
    }

    /* Al abrir la guia se vuelve a mirar, por si el repintado de la variante
       hubiera sustituido las filas despues del ultimo resaltado. */
    document.addEventListener('click', function (e) {
      if (e.target.closest('.size-guide-btn')) setTimeout(highlight, 30);
    });
  });
  /* ---------------- Codigo de descuento en el carrito ----------------
     Shopify no tiene endpoint para aplicar un codigo por AJAX: la unica via es
     la URL /discount/CODIGO, que lo guarda en la sesion y redirige. Asi que
     esto navega, y al volver hay que contar como fue.

     Se comprobo en produccion que el carrito refleja el descuento -sale en las
     lineas de total, que el tema ya pintaba-, de modo que el importe que se ve
     aqui ya es el que se va a cobrar. Sin eso este campo no valdria: escribir un
     codigo y no ver cambiar nada se lee como que ha fallado.

     Que codigo se intento se guarda en sessionStorage y NO en la URL de vuelta:
     Shopify descarta la query string que se le pase en `redirect`, asi que un
     ?dc= no sobrevivia al salto y el aviso de error no aparecia nunca.

     El resultado se consulta en /cart.js: `cart.discount_codes` no existe en
     Liquid -renderiza null-, solo en esa respuesta.

     No hay <form> propio: esto vive dentro del formulario del carrito y el HTML
     no admite formularios anidados. De ahi que se escuchen el clic y la tecla
     Enter por separado, y que el Enter tenga que frenarse para que no envie el
     formulario de fuera. */
  mod('cart-code', function () {
    const box = $('[data-cart-code]');
    const msg = $('[data-cart-code-msg]');
    const PENDING = 'ml_cart_code_tried';

    /* ---- Al volver de aplicar: decir si entro ---- */
    if (msg) {
      let tried = '';
      try {
        tried = (window.sessionStorage.getItem(PENDING) || '').trim();
        if (tried) window.sessionStorage.removeItem(PENDING);
      } catch (e) { tried = ''; }

      if (tried) {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            const codes = (cart && cart.discount_codes) || [];
            const hit = codes.filter(function (c) {
              return (c.code || '').toUpperCase() === tried.toUpperCase();
            })[0];
            /* Solo se avisa cuando falla. Si entro, aparece solo -con su nombre
               y su importe- en las lineas de total de aqui abajo.

               `applicable: false` cubre dos casos que Shopify no distingue: el
               codigo no existe, o existe pero no se junta con lo que ya hay en
               la bolsa. Se responde a los dos sin afirmar cual es. */
            if (!hit || hit.applicable === false) {
              msg.textContent = 'That code cannot be used on this bag. It may have expired, or it may not combine with the offer already applied.';
              msg.classList.add('cart-code__msg--bad');
              msg.hidden = false;
            }
          })
          .catch(function () { /* si no se puede comprobar, mejor callar que mentir */ });
      }
    }

    /* ---- Aplicar ---- */
    if (!box) return;
    const input = $('[data-cart-code-input]', box);
    const btn = $('[data-cart-code-apply]', box);
    if (!input || !btn) return;

    function apply() {
      const code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      if (msg) { msg.hidden = true; msg.classList.remove('cart-code__msg--bad'); }

      try { window.sessionStorage.setItem(PENDING, code); } catch (e) { /* sin aviso, pero se aplica igual */ }

      window.location.href = '/discount/' + encodeURIComponent(code) +
        '?redirect=' + encodeURIComponent(window.location.pathname);
    }

    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      /* Sin esto, el Enter envia el formulario del carrito que hay por encima y
         se recarga la pagina sin aplicar nada. */
      e.preventDefault();
      apply();
    });
  });
  /* ---------------- Desplegables suaves ----------------
     Un <details> nativo abre y cierra de golpe, y no hay forma de arreglarlo
     solo con CSS: al quitarle el atributo `open` el navegador esconde el
     contenido en el acto, asi que no queda nada que animar durante el cierre.

     De ahi que el cierre se haga al reves: se anima primero y se quita `open`
     cuando la animacion termina. La apertura es al derecho -poner `open` y
     animar-, pero necesita un fotograma de por medio: si se pone la altura
     final en el mismo turno que se muestra el contenido, el navegador ve un
     solo estado y no hay transicion.

     Se anima la altura en pixeles y no con `max-height` a ojo: un menu de tres
     enlaces y otro de ocho tardarian lo mismo en abrirse pero el corto pasaria
     media animacion parado.

     Alcance: [data-smooth] con un [data-smooth-body] dentro. Hoy los
     acordeones del pie y la nota del carrito. */
  mod('smooth-details', function () {
    const DUR = 260;

    function bodyOf(d) { return d.querySelector('[data-smooth-body]'); }

    /* La animacion en si. Solo necesita el elemento cuya altura se mueve, asi
       que sirve igual para el cuerpo de un <details> que para un bloque suelto
       que se enseña y se esconde con `hidden`. La marca de "animando" va sobre
       ese mismo elemento y sobre su <details> si lo tiene. */
    function runOn(body, from, to, onEnd, owner) {
      body.setAttribute('data-animating', '');
      if (owner) owner.setAttribute('data-animating', '');
      body.style.overflow = 'hidden';
      body.style.height = from + 'px';
      /* Leer una propiedad de layout fuerza al navegador a asumir el estado de
         partida antes de cambiarlo. Sin esto salta directo al final. */
      void body.offsetHeight;
      body.style.height = to + 'px';

      let closed = false;
      const finish = function () {
        if (closed) return;
        closed = true;
        body.removeEventListener('transitionend', onTr);
        if (onEnd) onEnd();
        /* Se devuelve la altura a auto: dejarla clavada en pixeles rompe el
           desplegable si luego cambia su contenido o el ancho de la ventana. */
        body.style.height = '';
        body.style.overflow = '';
        body.removeAttribute('data-animating');
        if (owner) owner.removeAttribute('data-animating');
      };
      const onTr = function (e) {
        if (e.propertyName === 'height' && e.target === body) finish();
      };
      body.addEventListener('transitionend', onTr);
      /* Red de seguridad: si la transicion no llega a dispararse -pestaña de
         fondo, un display:none heredado- el desplegable se quedaria a medias
         para siempre. */
      setTimeout(finish, DUR + 120);
    }

    function run(d, body, from, to, onEnd) { runOn(body, from, to, onEnd, d); }

    /* Misma animacion de altura, pero para lo que no es un <details>: un bloque
       que se muestra y se esconde con `hidden`. Lo usa cart.js para el carril de
       recomendados del carrito, que vive en otro archivo pero comparte pagina.

       Se publica en window por eso: los dos scripts se cargan sueltos, sin
       modulos, y esta es la unica via de que uno alcance al otro. Se llama en el
       clic, mucho despues de que ambos hayan arrancado, asi que el orden de
       carga no importa. */
    window.MLslideToggle = function (el, open) {
      if (!el) return;
      if (open) {
        if (!el.hidden) return;
        el.hidden = false;
        runOn(el, 0, el.scrollHeight, null);
      } else {
        if (el.hidden) return;
        runOn(el, el.scrollHeight, 0, function () { el.hidden = true; });
      }
    };

    /* Se publica para que el acordeon exclusivo -el que cierra los hermanos al
       abrir uno- pueda cerrarlos con la misma animacion en vez de de golpe. */
    window.MLsmoothClose = function (d) {
      if (!d || !d.open || d.hasAttribute('data-animating')) return;
      const body = bodyOf(d);
      if (!body) { d.open = false; return; }
      run(d, body, body.scrollHeight, 0, function () { d.open = false; });
    };

    document.addEventListener('click', function (e) {
      const sum = e.target.closest('summary');
      if (!sum) return;
      const d = sum.parentElement;
      if (!d || d.tagName !== 'DETAILS' || !d.hasAttribute('data-smooth')) return;

      const body = bodyOf(d);
      if (!body) return;

      /* Mientras una animacion corre se ignoran los clics: alternar a mitad
         deja la altura congelada en un valor intermedio. */
      if (d.hasAttribute('data-animating')) { e.preventDefault(); return; }

      e.preventDefault();

      if (d.open) {
        run(d, body, body.scrollHeight, 0, function () { d.open = false; });
      } else {
        d.open = true;
        run(d, body, 0, body.scrollHeight, null);
      }
    });
  });
  /* ---------------- La cabecera vuelve al subir ----------------
     Antes no volvia nunca. Estaba con `position: sticky`, pero su contenedor
     mide justo lo que ella, asi que no tenia recorrido donde pegarse y se iba
     con el scroll como cualquier otro bloque: a 2000px de scroll quedaba en
     -1960. Para cambiar de pagina habia que subir del todo.

     Ahora, una vez que se ha ido de la pantalla, pasa a flotante y responde al
     sentido del scroll:
       - bajando, se retira;
       - subiendo, asoma en proporcion a lo que se sube, no de golpe;
       - subiendo lo suficiente, se queda fija hasta que se vuelva a bajar.

     El hueco que deja al volverse flotante se reserva en su contenedor, o la
     pagina daria un tiron hacia arriba justo al despegarla. */
  mod('header-reveal', function () {
    const wrap = $('.header-wrap');
    if (!wrap) return;
    const holder = wrap.parentElement;

    /* Cuanto hay que subir para que se quede fija del todo. Por debajo de eso
       solo asoma la parte proporcional, que es lo que da la sensacion de que
       acompaña al dedo en vez de aparecer de golpe. */
    const FULL = 90;
    /* Margen para no reaccionar al temblor del scroll ni al rebote elastico de
       iOS, que manda deltas de un par de pixeles en ambos sentidos. */
    const NOISE = 4;

    let floating = false;
    let lastY = window.scrollY;
    let upAccum = 0;
    let shown = 0;      /* 0 = escondida, 1 = del todo a la vista */
    let locked = false; /* subio lo suficiente: se queda */
    let height = 0;
    let ticking = false;

    function measure() {
      height = wrap.offsetHeight || 0;
    }

    function float(on) {
      if (on === floating) return;
      floating = on;
      if (on) {
        /* Se reserva el hueco antes de sacarla del flujo. */
        measure();
        holder.style.minHeight = height + 'px';
        wrap.classList.add('is-float');
      } else {
        wrap.classList.remove('is-float');
        holder.style.minHeight = '';
        wrap.style.transform = '';
        shown = 0; locked = false; upAccum = 0;
      }
    }

    function paint() {
      if (!floating) return;
      /* Sin transicion CSS mientras se arrastra: la posicion la manda el scroll
         y una transicion encima la dejaria siempre por detras del dedo. Solo se
         activa al fijarla o al retirarla del todo. */
      wrap.style.transform = 'translateY(' + (-(1 - shown) * 100).toFixed(2) + '%)';
    }

    function onScroll() {
      const y = Math.max(0, window.scrollY);
      const delta = y - lastY;
      lastY = y;

      if (!height) measure();

      /* Mientras la cabecera de verdad sigue a la vista no hay nada que imitar. */
      if (y <= height + 4) {
        float(false);
        return;
      }

      if (!floating) {
        /* Se despega ya escondida: aparecer de golpe al cruzar el umbral seria
           justo el tiron que se quiere evitar. */
        float(true);
        shown = 0; locked = false; upAccum = 0;
        wrap.classList.add('is-instant');
        paint();
        /* Se devuelve la transicion en el siguiente turno, ya colocada. */
        setTimeout(function () { wrap.classList.remove('is-instant'); }, 0);
        return;
      }

      if (delta > NOISE) {
        /* Bajando: se retira, y con transicion para que no se vaya a tirones. */
        upAccum = 0;
        if (shown !== 0) { locked = false; shown = 0; paint(); }
        return;
      }

      if (delta < -NOISE) {
        upAccum += -delta;
        if (locked) return;
        if (upAccum >= FULL) { locked = true; shown = 1; }
        else { shown = upAccum / FULL; }
        paint();
      }
    }

    function onScrollRaf() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; onScroll(); });
    }

    window.addEventListener('scroll', onScrollRaf, { passive: true });
    window.addEventListener('resize', function () { measure(); if (floating) holder.style.minHeight = height + 'px'; });
    /* La cabecera se re-renderiza con cada cambio del carrito y cambia de alto
       al aparecer el contador, asi que conviene volver a medirla. */
    document.addEventListener('cart:updated', measure);
    onScroll();
  });
  /* ---------------- Desplegable de orden ----------------
     La lista que abre un <select> la dibuja el sistema operativo: no se puede
     estilar ni animar. Asi que se monta una propia encima y el <select> real se
     queda debajo, oculto, haciendo de fuente de la verdad.

     Eso es lo que mantiene todo lo demas en pie: al elegir se le pone el valor
     al <select> y se le lanza un `change`, que es justo lo que ya escuchaba el
     modulo de filtros para recargar la rejilla. Nada aguas abajo se entera de
     que hay una lista distinta.

     Y si este codigo no llega a ejecutarse, el boton y la lista siguen con
     `hidden` puesto desde Liquid y se ve el <select> de siempre, funcionando. */
  mod('sort-dropdown', function () {
    const box = $('[data-sort]');
    if (!box) return;
    const select = $('[data-facet-sort]', box);
    const btn = $('[data-sort-btn]', box);
    const list = $('[data-sort-list]', box);
    const label = $('[data-sort-label]', box);
    if (!select || !btn || !list) return;

    /* A partir de aqui manda la lista propia: se enseña el boton y la clase
       esconde el <select> por CSS. */
    btn.hidden = false;
    box.classList.add('is-enhanced');

    const opts = $$('.coll-sort__opt', list);
    let open = false;

    function close(focusBtn) {
      if (!open) return;
      open = false;
      list.classList.remove('is-shown');
      btn.setAttribute('aria-expanded', 'false');
      /* El `hidden` se retrasa hasta que acaba la transicion: ponerlo ya la
         cortaria en seco, porque display:none no se anima. */
      setTimeout(function () { if (!open) list.hidden = true; }, 220);
      if (focusBtn) btn.focus();
    }

    function show() {
      if (open) return;
      open = true;
      list.hidden = false;
      /* Leer el layout separa los dos estados sin depender de que el navegador
         este pintando, que es lo que falla con requestAnimationFrame en una
         pestaña de fondo. */
      void list.offsetHeight;
      list.classList.add('is-shown');
      btn.setAttribute('aria-expanded', 'true');
      const sel = opts.filter(function (o) { return o.getAttribute('aria-selected') === 'true'; })[0];
      (sel || opts[0]).focus();
    }

    function choose(opt) {
      if (!opt) return;
      opts.forEach(function (o) { o.setAttribute('aria-selected', String(o === opt)); });
      if (label) label.textContent = opt.textContent.trim();
      const value = opt.getAttribute('data-sort-value');
      if (select.value !== value) {
        select.value = value;
        /* Este evento es el que recarga la rejilla. Sin el, la lista cambiaria
           de aspecto y no ordenaria nada. */
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      close(true);
    }

    btn.addEventListener('click', function () { open ? close(false) : show(); });

    list.addEventListener('click', function (e) {
      const opt = e.target.closest('.coll-sort__opt');
      if (opt) choose(opt);
    });

    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) { e.preventDefault(); close(true); return; }

      if (!open) {
        if (e.target === btn && (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault(); show();
        }
        return;
      }

      const i = opts.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); opts[Math.min(opts.length - 1, i + 1)].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); opts[Math.max(0, i - 1)].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); opts[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); opts[opts.length - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(opts[i]); }
    });

    /* Tabular fuera cierra: dejar la lista abierta detras del foco confunde. */
    box.addEventListener('focusout', function (e) {
      if (!box.contains(e.relatedTarget)) close(false);
    });

    document.addEventListener('click', function (e) {
      if (open && !e.target.closest('[data-sort]')) close(false);
    });
  });
})();
